<div *ngIf="filtersLoaded | async">
    <div class="d-flex flex-column h-100 position-relative">
        <div class="appBodyWrapper d-flex h-100 flex-fill flex-column QRMerchantPage">
            <div class="appHeader">
                <div class="container">
                    <h3 class="fs-25 fw-semibold mb-2 text-capitalize">Shop online at india's top brands</h3>
                    <div class="banner-card rounded-lg">
                        <div class="banner-card-body text-center">
                            <img src="./assets/images/tvs_banner.png" alt="emi-card" class="img-fluid">
                        </div>
                    </div>
                </div>

                <div class="row d-flex g-0" id="v-pills-tab" role="tablist">

                    <div class="col-3" *ngFor="let data of mainList;">
                        <div class="content-wrapper d-flex flex-column tab-button pointer">
                            <p [ngClass]="{'active': data.CATEGORY_NAME==selectedCategory}" id="v-pills-mobile-tab"
                                data-bs-toggle="pill" data-bs-target="#v-pills-mobile" role="tab"
                                aria-controls="v-pills-mobile" aria-selected="true"><img src="{{data.M_IMG_PATH}}"
                                    alt="{{data.M_IMG_PATH}}"
                                    (click)="getSelectedCategoryList(data.CATEGORY_NAME)">{{data.CATEGORY_NAME.replace("and",
                                "&")}}</p>
                        </div>
                    </div>

                </div>


            </div>
            <div class="appbody h-100">
                <div class="centerContent">
                    <div class="container h-100">
                        <h5 class="fs-18 lh-24 fw-semibold mb-2 pb-1 text-capitalize">Select brand name</h5>

                        <div class="tab-content" id="v-pills-tabContent">
                            <div class="row d-flex tab-pane fade g-2 show active" id="v-pills-mobile" role="tabpanel"
                                aria-labelledby="v-pills-mobile-tab">
                                <div class="col-4" *ngFor="let categoryData of brandList;">
                                    <div class="col-wrap py-1">
                                        <div
                                            class="card d-flex align-items-center justify-content-center border-0 imgCard">
                                            <a (click)="redirectUrl(categoryData)" target="_blank">
                                                <img src="{{categoryData.M_IMG_PATH}}" alt="{{categoryData.BRAND_NAME}}"
                                                    class="img-fluid" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottomContent bg-white">
                    <div class="container">
                        <h5 class="fs-18 lh-24 fw-semibold mb-3 text-capitalize">How It Works</h5>
                        <div class="card border-light mb-3">
                            <div class="card-body">
                                <img src="./assets/images/step_01.png" alt="" class="img-fluid mb-2" />
                                <h5 class="fs-14 lh-20 fw-semibold mb-2">
                                    On Payment Page choose <span class="text-green">EMI/Cardless EMI</span>
                                    after
                                    product section
                                </h5>
                                <img src="./assets/images/step_1_img.png" alt="" class="img-fluid" />
                            </div>
                        </div>
                        <div class="card border-light mb-3">
                            <div class="card-body">
                                <img src="./assets/images/step_02.png" alt="" class="img-fluid mb-2" />
                                <h5 class="fs-14 lh-20 fw-semibold mb-2">
                                    Under Cardless EMI select <span class="text-green">TVS Credit EMI</span>
                                    option
                                </h5>
                                <img src="./assets/images/step_2_img.png" alt="" class="img-fluid" />
                            </div>
                        </div>
                        <div class="card border-light mb-3">
                            <div class="card-body">
                                <img src="./assets/images/step_03.png" alt="" class="img-fluid mb-2" />
                                <h5 class="fs-14 lh-20 fw-semibold mb-2">
                                    Verify EMI amount, Tenure along with your <span class="text-green">DOB</span>
                                    then
                                    submit <span class="text-green">OTP</span> for your product payment
                                </h5>
                                <img src="./assets/images/step_3_img.png" alt="" class="img-fluid mb-3 pb-1" />
                                <a href="javascript:void(0)"
                                    class="btn btn-primary fs-14 fw-medium rounded-pill px-4 py-1 mx-auto pe-none verify-btn ">Verify
                                    & Confirm</a>
                            </div>
                        </div>
                        <p class="fs-12 fw-medium mb-0 text-center">By choosing the merchants name you will be
                            redirecting to the respective website/app to continue your purchase</p>
                    </div>
                </div>
            </div>
        </div>
        <loader *ngIf="loader"></loader>